import React from 'react';
import { TemplateRenderProps } from './types';
import { FormFields, AddonsSelector, CouponSection, TrustAndSecurityBadge, SocialProofAndFomo } from './CheckoutCommonElements';
import { BillingCycleSelector, PriceBreakdown } from './CheckoutSummaryElements';

export const MinimalTemplate: React.FC<TemplateRenderProps> = ({
  plan,
  config,
  formData,
  onInputChange,
  billingCycle,
  onChangeCycle,
  selectedAddonIds,
  onToggleAddon,
  appliedCoupon,
  onApplyCoupon,
  onRemoveCoupon,
  onSubmitInfo,
  isCapturing,
  currencySymbol,
  addonsTotal,
  discountAmount,
  finalTotal,
}) => {
  return (
    <div
      className="min-h-full p-4 md:p-10 flex items-center justify-center"
      style={{
        backgroundColor: config.backgroundColor || '#ffffff',
        color: config.textColor || '#09090b',
        fontFamily: config.fontFamily || 'Inter, sans-serif',
      }}
    >
      <div className="w-full max-w-lg space-y-6">
        <div className="text-center space-y-2">
          {config.logoUrl && <img src={config.logoUrl} alt="Logo" className="h-7 mx-auto object-contain" />}
          <h1 className="text-2xl font-bold tracking-tight text-slate-900">{config.headerMain || `Subscribe to ${plan.tier}`}</h1>
          <p className="text-xs text-slate-500 font-medium">{config.headerSub || 'Quick, simple and secure checkout.'}</p>
        </div>

        <div className="bg-slate-50/70 p-4 rounded-xl border border-slate-200/80 space-y-4">
          <BillingCycleSelector billingCycle={billingCycle} onChangeCycle={onChangeCycle} config={config} />
          <PriceBreakdown plan={plan} billingCycle={billingCycle} addonsTotal={addonsTotal} discountAmount={discountAmount} finalTotal={finalTotal} currencySymbol={currencySymbol} />
        </div>

        <SocialProofAndFomo config={config} />

        <form onSubmit={onSubmitInfo} className="space-y-4">
          <FormFields config={config} formData={formData} onInputChange={onInputChange} />
          <AddonsSelector addons={config.addons} selectedAddonIds={selectedAddonIds} onToggleAddon={onToggleAddon} currency={plan.currency} />
          <CouponSection config={config} appliedCoupon={appliedCoupon} onApplyCoupon={onApplyCoupon} onRemoveCoupon={onRemoveCoupon} />

          <button
            type="submit"
            disabled={isCapturing}
            className="w-full py-3.5 text-xs font-bold uppercase tracking-wider text-white shadow-sm transition-all hover:opacity-90 disabled:opacity-50"
            style={{
              backgroundColor: config.primaryColor || '#000000',
              borderRadius: config.buttonRadius || '8px',
            }}
          >
            {isCapturing ? 'Verifying...' : config.buttonText || `Pay ${currencySymbol}${finalTotal.toFixed(2)}`}
          </button>
        </form>

        <TrustAndSecurityBadge config={config} />
        {config.footerText && <p className="text-[10px] text-slate-400 text-center">{config.footerText}</p>}
      </div>
    </div>
  );
};
